import { ValueOf } from '@vy/utils';

export const PRODUCT_USAGE_BREAKDOWN_DATE_RESOLUTIONS = Object.freeze({
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
});

export type ProductUsageBreakdownDateResolution = ValueOf<typeof PRODUCT_USAGE_BREAKDOWN_DATE_RESOLUTIONS>;
